import React from 'react';
import { Form, Button, Checkbox, Upload, Spin, Space } from '@douyinfe/semi-ui';
import { IconUpload, IconServerStroked, IconFolderStroked, IconDownloadStroked, IconLockStroked, IconUserStroked, IconEditStroked, IconArrowLeft, IconUnChainStroked, IconChainStroked, IconMonitorStroked, IconStoryStroked } from '@douyinfe/semi-icons';
import { isEmpty, isNull, isNaN } from 'lodash';

// Import controllers
import { getCDNFileList, checkFileExist, downloadFilesViaFTP } from '../../../controllers/initController';
import config from '../../../config';

class DownloadInfobases extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cdn_selected: false,
            local_selected: false,
            upload_selected: false,
            download_type_selected: false,
            cdn_choosed: false,
            cdn_checked: false,
            upload_started: false,
            upload_finished: false,
            cdn_url: null,
            cdn_port: null,
            cdn_path: null,
            cdn_login: null,
            cdn_password: null,
            cdn_files: [],
            cdn_files_checked: [],
            cdn_connected: false,
        };
        this.handleDownload = this.handleDownload.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.changeType = this.changeType.bind(this);
        this.handleDisconnect = this.handleDisconnect.bind(this);
        this.UploadStatusChange = this.UploadStatusChange.bind(this);
        this.CheckUploadAvailability = this.CheckUploadAvailability.bind(this);
        this.handleFinishUpload = this.handleFinishUpload.bind(this);
        this.SelectFilesFromFTP = this.SelectFilesFromFTP.bind(this);
    }

    SelectFilesFromFTP = async () => {
        var infobases = document.querySelectorAll('input[type=checkbox]');

        var values = [];
        for (var index = 0; index < infobases.length; index++) {
            if (infobases[index].checked) {
                values.push(infobases[index].value);
            }
        }

        this.setState({ cdn_files_checked: values });
    };

    handleFinishUpload = async () => {
        this.setState({ upload_finished: true });
        this.props.check(false);
    };

    CheckUploadAvailability = async (newFile) => {
        let file = newFile.pop();

        let allow = false;

        let ext = file.name.substring(file.name.lastIndexOf('.') + 1);

        const toaster = this.props.toaster;

        if (ext === 'dt') {
            let check = await checkFileExist(file);

            if (isEmpty(check) || isNull(check)) return toaster.error({ content: 'Что-то пошло не так, повторите запрос!' });
            if (check.success === false) return toaster.error({ content: check.message });
            if (check.success === true) return toaster.success({ content: check.message });
        } else {
            allow = false;
        }

        return new Promise(resolve => {
            setTimeout(() => {
                allow === true ? resolve(true) : resolve(false);
            }, 1000);
        });
    };

    UploadStatusChange = async (response, file) => {
        const toaster = this.props.toaster;
        toaster.success({ content: response.message });
        this.setState({ upload_started: true });
    };

    handleGetListOfFiles = async () => {
        const toaster = this.props.toaster;
        if (isEmpty(this.state.cdn_url) || isNull(this.state.cdn_url)) return toaster.error({ content: 'Укажите адрес сервера!' });

        const re = /^([\wёa-я-]{2,}\.)+[\wёa-я-]{2,}$/i;
        const re_ip = /^((?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])[.]){3}(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])$/;

        if (re.test(this.state.cdn_url) === false && re_ip.test(this.state.cdn_url) === false) return toaster.error({ content: 'Некорректный адрес сервера!' });

        if (isEmpty(this.state.cdn_port) || isNull(this.state.cdn_port) || isNaN(this.state.cdn_port) || this.state.cdn_port < 0) return toaster.error({ content: 'Укажите порт сервера!' });

        toaster.info({ content: 'Попытка соединения с сервером. Пожалуйста, подождите...' });

        let fields = {
            url: this.state.cdn_url,
            port: this.state.cdn_port,
            path: this.state.cdn_path,
            login: this.state.cdn_login,
            password: this.state.cdn_password,
        };

        let getFileList = await getCDNFileList(fields);

        if (!isEmpty(getFileList.data.fileList) || !isNull(getFileList.data.fileList)) {
            toaster.success({ content: getFileList.message });
            this.setState({ cdn_connected: true, cdn_files: getFileList.data.fileList, cdn_checked: true });
            return;
        } else {
            toaster.error({ content: getFileList.message });
            this.setState({ cdn_connected: false, cdn_files: [] });
            return;
        }
    };

    handleDisconnect = async () => {
        this.setState({ cdn_connected: false, cdn_files: [], cdn_files_checked: [] });
    };

    handleDownload = async () => {
        const toaster = this.props.toaster;

        if (isEmpty(this.state.cdn_url) || isNull(this.state.cdn_url)) return toaster.error({ content: 'Укажите адрес сервера!' });

        if (isEmpty(this.state.cdn_port) || isNull(this.state.cdn_port)) return toaster.error({ content: 'Укажите порт сервера!' });

        if (isEmpty(this.state.cdn_files_checked) || isNull(this.state.cdn_files_checked)) return toaster.error({ content: 'Файлы для загрузки не выбраны!' });

        let fields = {
            url: this.state.cdn_url,
            port: this.state.cdn_port,
            path: this.state.cdn_path,
            login: this.state.cdn_login,
            password: this.state.cdn_password,
            files: this.state.cdn_files_checked,
        };

        this.setState({ cdn_choosed: true, upload_started: true });

        let downloadFiles = await downloadFilesViaFTP(fields);
        if (downloadFiles.data.success === false) {
            this.setState({ cdn_choosed: false, upload_started: false });
            return toaster.error({ content: downloadFiles.data.message });
        } else {
            this.setState({ upload_finished: true });
            this.props.check(false);
        }
    };

    changeType = async (value) => {
        if (value === 'cdn') {
            this.setState({
                cdn_selected: true,
                local_selected: false,
                upload_selected: false,
                download_type_selected: true,
                cdn_choosed: false,
                cdn_checked: false,
                upload_started: false,
                upload_finished: false,
                cdn_url: null,
                cdn_port: null,
                cdn_path: null,
                cdn_login: null,
                cdn_password: null,
                cdn_files: [],
                cdn_files_checked: [],
                cdn_connected: false,
            });
            this.props.check(true);
            return;
        }

        if (value === 'upload') {
            this.setState({
                cdn_selected: false,
                local_selected: false,
                upload_selected: true,
                download_type_selected: true,
                cdn_choosed: false,
                cdn_checked: false,
                upload_started: false,
                upload_finished: false,
                cdn_url: null,
                cdn_port: null,
                cdn_path: null,
                cdn_login: null,
                cdn_password: null,
                cdn_files: [],
                cdn_files_checked: [],
                cdn_connected: false,
            });
            this.props.check(true);
            return;
        }

        if (value === 'local') {
            this.setState({
                cdn_selected: false,
                local_selected: true,
                upload_selected: false,
                download_type_selected: true,
                cdn_choosed: false,
                cdn_checked: false,
                upload_started: false,
                upload_finished: false,
                cdn_url: null,
                cdn_port: null,
                cdn_path: null,
                cdn_login: null,
                cdn_password: null,
                cdn_files: [],
                cdn_files_checked: [],
                cdn_connected: false,
            });
            this.props.check(false);
            return;
        }
    };

    handleBack = async () => {
        this.setState({
            cdn_selected: false,
            local_selected: false,
            upload_selected: false,
            download_type_selected: false,
            cdn_choosed: false,
            cdn_checked: false,
            upload_started: false,
            upload_finished: false,
            cdn_url: null,
            cdn_port: null,
            cdn_path: null,
            cdn_login: null,
            cdn_password: null,
            cdn_files: [],
            cdn_files_checked: [],
            cdn_connected: false,
        });

        this.props.check(true);
    };

    componentDidMount() {
        this.props.check(true);
    }

    render() {
        let { cdn_selected, local_selected, upload_selected, cdn_choosed, cdn_checked, cdn_connected, upload_started, upload_finished, download_type_selected, cdn_files, cdn_files_checked } = this.state;

        return (
            <Form fluid>
                {download_type_selected ? (
                    <>
                        {cdn_selected && (
                            cdn_choosed ? (
                                upload_finished ? (
                                    <div className="modal-fixed-custom">
                                        <Form.Group style={{ textAlign: 'center' }}>
                                            <span style={{ color: 'green', fontSize: 48, paddingBottom: 15 }}>✓</span>
                                            <span style={{ display: 'block' }}>Файлы успешно загружены!</span>
                                        </Form.Group>
                                    </div>
                                ) : (
                                    <div className="modal-fixed-custom">
                                        <Form.Group style={{ textAlign: 'center' }}>
                                            {upload_started && (
                                                <div style={{ width: 120, margin: 'auto' }}>
                                                    <Spin size="large" style={{ width: '100%', textAlign: 'center' }} tip="Идет загрузка..." />
                                                </div>
                                            )}
                                            {cdn_checked && (
                                                <span style={{ display: 'block', padding: '8px 10px' }}>
                                                    <b>Подключение к серверу: </b>Успешно
                                                </span>
                                            )}
                                            {upload_started && (
                                                <div style={{ display: 'block' }}>
                                                    <span style={{ display: 'block', padding: '8px 10px' }}>
                                                        <b>Загрузка информационных баз: </b>
                                                    </span>
                                                    {cdn_files_checked.map((item) => (
                                                        <span key={item} style={{ display: 'block', padding: '8px 10px' }}>
                                                            <b>{item}</b>
                                                        </span>
                                                    ))}
                                                </div>
                                            )}
                                            {!cdn_checked && (
                                                <Button icon={<IconArrowLeft />} onClick={this.handleBack}>
                                                    Назад
                                                </Button>
                                            )}
                                        </Form.Group>
                                    </div>
                                )
                            ) : (
                                <div className="modal-fixed-custom">
                                    <div style={{ maxWidth: 600, margin: 'auto' }}>
                                        <Form.Input
                                            field="cdn_url"
                                            label="Сервер"
                                            prefix={<IconServerStroked />}
                                            placeholder="test.com (без протокола)"
                                            disabled={cdn_connected}
                                            onChange={(value) => this.setState({ cdn_url: value })}
                                        />
                                        <Form.Input
                                            field="cdn_path"
                                            label="Путь к файлам"
                                            prefix={<IconFolderStroked />}
                                            placeholder="/path/to/infobases/files"
                                            disabled={cdn_connected}
                                            onChange={(value) => this.setState({ cdn_path: value })}
                                        />
                                        <Form.Input
                                            field="cdn_port"
                                            label="Порт"
                                            prefix={<IconEditStroked />}
                                            type="number"
                                            placeholder="21"
                                            disabled={cdn_connected}
                                            onChange={(value) => this.setState({ cdn_port: value })}
                                        />
                                        <Form.Input
                                            field="cdn_login"
                                            label="Пользователь"
                                            prefix={<IconUserStroked />}
                                            placeholder="admin"
                                            disabled={cdn_connected}
                                            onChange={(value) => this.setState({ cdn_login: value })}
                                        />
                                        <Form.Input
                                            field="cdn_password"
                                            label="Пароль"
                                            prefix={<IconLockStroked />}
                                            type="password"
                                            disabled={cdn_connected}
                                            onChange={(value) => this.setState({ cdn_password: value })}
                                        />
                                        {cdn_connected && (
                                            <div style={{ maxHeight: 370, overflowY: 'auto', marginTop: 16 }}>
                                                {cdn_files.map((item) => (
                                                    <div key={item.name} style={{ display: 'flex', alignItems: 'center', padding: '8px' }}>
                                                        <Checkbox
                                                            name="cdn_files"
                                                            value={item.name}
                                                            onChange={this.SelectFilesFromFTP}
                                                        />
                                                        <div style={{ flex: 1, textAlign: 'center', overflow: 'hidden' }}>{item.name}</div>
                                                        <div style={{ width: 100, textAlign: 'center' }}>{item.size}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        <Space style={{ padding: '10px 0' }}>
                                            {!cdn_connected && (
                                                <Button icon={<IconArrowLeft />} onClick={this.handleBack}>
                                                    Назад
                                                </Button>
                                            )}
                                            {cdn_connected ? (
                                                <Button icon={<IconUnChainStroked />} onClick={this.handleDisconnect}>
                                                    Отключиться
                                                </Button>
                                            ) : (
                                                <Button icon={<IconChainStroked />} onClick={this.handleGetListOfFiles}>
                                                    Подключиться
                                                </Button>
                                            )}
                                            {cdn_connected && (
                                                <Button icon={<IconDownloadStroked />} onClick={this.handleDownload}>
                                                    Загрузить
                                                </Button>
                                            )}
                                        </Space>
                                    </div>
                                </div>
                            )
                        )}
                        {upload_selected && (
                            upload_finished ? (
                                <div className="modal-fixed-custom">
                                    <Form.Group style={{ textAlign: 'center' }}>
                                        <span style={{ color: 'green', fontSize: 48, paddingBottom: 15 }}>✓</span>
                                        <span style={{ display: 'block' }}>Файлы успешно загружены!</span>
                                    </Form.Group>
                                </div>
                            ) : (
                                <div className="modal-fixed-custom">
                                    <Upload
                                        action={config.url + config.api.public + '/upload/client'}
                                        draggable={true}
                                        accept='.dt'
                                        dragMainText="Нажмите для выбора файла или передащите его вручную"
                                        dragSubText="Файлы с расширением *.dt"
                                        beforeUpload={(newFile) => this.CheckUploadAvailability(newFile)}
                                        onSuccess={(response, file) => this.UploadStatusChange(response, file)}
                                    >
                                        <div style={{ flexDirection: 'column', height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <IconUpload style={{fontSize: '48px', color: 'var(--semi-color-primary)'}} />
                                            <span>Перетащите копии информационных баз (*.dt) в это поле для загрузки</span>
                                        </div>
                                    </Upload>
                                    {!upload_started && (
                                        <Button icon={<IconArrowLeft />} style={{ marginTop: 15 }} onClick={this.handleBack}>
                                            Назад
                                        </Button>
                                    )}
                                    {upload_started && (
                                        <Button icon={<IconStoryStroked />} style={{ marginTop: 15 }} onClick={this.handleFinishUpload}>
                                            Готово
                                        </Button>
                                    )}
                                </div>
                            )
                        )}
                        {local_selected && (
                            <div className="modal-fixed-custom" style={{ textAlign: 'center' }}>
                                <span style={{ color: 'green', fontSize: 48, paddingBottom: 15 }}>✓</span>
                                <div>Будут использованы копии информационных баз из дистрибутива платформы</div>
                            </div>
                        )}
                    </>
                ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
                        <Space align="center">
                            <Button
                                icon={<IconServerStroked style={{ fontSize: 48 }} />}
                                onClick={() => this.changeType('cdn')}
                                className="distribution_type"
                            >
                                <div style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>Удаленный FTP/CDN</div>
                                <div style={{ fontSize: 12, color: '#666' }}>Загрузка копий информационных баз (*.dt) из удаленного источника</div>
                            </Button>
                            <Button
                                icon={<IconMonitorStroked style={{ fontSize: 48 }} />}
                                onClick={() => this.changeType('upload')}
                                className="distribution_type"
                            >
                                <div style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>Из локального источника</div>
                                <div style={{ fontSize: 12, color: '#666' }}>Загрузка копий информационных баз с локального диска пользователя</div>
                            </Button>
                            <Button
                                icon={<IconFolderStroked style={{ fontSize: 48 }} />}
                                onClick={() => this.changeType('local')}
                                className="distribution_type"
                            >
                                <div style={{ fontSize: 18, fontWeight: 500, marginBottom: 4 }}>Из дистрибутива</div>
                                <div style={{ fontSize: 12, color: '#666' }}>Использовать копии информационных баз из дистрибутива платформы</div>
                            </Button>
                        </Space>
                    </div>
                )}
            </Form>
        );
    }
}

export default DownloadInfobases;